const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Napravite izbor",
  seeAll: "Pogledajte sve",
  clear: "Očistite",
  back: "Nazad",
  save: "Sačuvajte",
  close: "Zatvorite",
  of: "Od",
  to: "Do",
  copyrights: "© {date} Bridgestone Solutions. Sva prava zadržana.",
  pageNotFound: "Stranica nije pronađena",
  accessDenied: "Pristup odbijen",
  search: "Pretražite",
  year: "Godina",
  buttons: {
    loading: "Učitavanje...",
    export: "Izvezite",
    delete: "Obrišite",
    save: "Sačuvajte",
    cancel: "Otkažite",
    next: "Dalje",
    back: "Nazad",
    skip: "Preskočite",
    send: "Pošaljite",
    clear: "Očistite",
    close: "Zatvorite",
    readNow: "Pročitajte sada",
    pointsList: "Lista poena",
    more: "Više",
    reportError: "Prijavite grešku",
    accept: "Prihvatite",
    download: "Preuzmite",
    downloadAll: "Preuzmi sve",
    selectAll: "Odaberi sve",
    deselectAll: "Poništi odabir",
    downloadSelection: "Preuzmi odabrano",
    dealerInfoDownload: "PREUZMITE",
    toTheBasket: "U korpu",
    toOrderDelivery: "Nastavite na adresu za dostavu",
    discover: "Otkrijte",
    newAddress: "Kreirajte novu adresu za dostavu",
    selectAddressBtn: "Izaberite adresu za dostavu",
    toOrderSummary: "Na pregled narudžbe",
    placeOrder: "Obavezujuća narudžba",
    toDashboard: "Na početnu stranicu",
    newOrder: "Nova narudžba",
    userOrders: "Na vaše narudžbe",
    toSearch: "Pretražite",
    select: "Izaberite",
    moreCustomerNumbers: "+ DODAJTE VIŠE BROJEVA KUPACA",
    loadMore: "Učitajte više",
    toStaffDashboard: "Na kontrolnu tablu",
    toQuiz: "Na kviz",
    vouchers: "Vaučeri",
    exchangeVoucher: "Unovčite kod vaučera",
    confirm: "Potvrdite",
    sharePoints: "Podelite poene",
    create: "Kreirajte",
    update: "Ažurirajte",
    toBDrive: "U B-Drive",
    preview: "Pregled",
    clickHere: "Prikaži detalje",
    setFilters: "Molimo postavite <b>najviše jedan filter po koloni</b>",
    all: "Sve",
  },
  tooltips: {
    info: "Treba vam pomoć? 01 92 64 88 50 0",
  },
  confirmation: {
    header: "Potrebna potvrda",
    message: "Da li želite da obrišete ovaj unos?",
  },
  nav: {
    consents: "Saglasnosti",
    dashboard: "Kontrolna tabla",
    accountDashboard: "Kontrolna tabla",
    account: "Profil",
    mailbox: "Primljena pošta",
    singleMailbox: "Poruke",
    stammdaten: "Osnovni podaci",
    news_feeds: "Vesti",
    pointsOverview: "Pregled poena",
    rewardsOverview: "Pregled poena",
    about: "O BS Plus",
    service_number: "Kontakt servis",
    shop: "Shop nagrada",
    salesPromotions: "Prodajne promocije",
    promotions: "Moj nalog",
    shopCategory: "Shop nagrada",
    productDetails: "Detalji proizvoda",
    userOrders: "Korisničke narudžbe",
    shoppingCart: "Korpa",
    orderDelivery: "Adresa za dostavu",
    orderSummary: "Pregled narudžbe",
    orderComplete: "Narudžba završena",
    text_page: "Statička stranica",
    staff: "Kontrolna tabla servisa",
    onlineTrainings: "Onlajn treninge",
    trainings: "Treninge",
    training: "Trening",
    trainingForm: "Forma za trening",
    staffVouchers: "Vaučeri",
    wholesalerVouchers: "Vaučeri",
    brochure_prices: "Cenovnici i brošure",
    investment: "Podrska investicijama",
    media: "Mediji",
    medias: "Mediji",
    wholesaler: "Kontrolna tabla veletrgovca",
    contact_service: "Kontakt informacije i servis",
    productInfo: "INFORMACIJE O PROIZVODU",
    bDrive: "Slike proizvoda",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Uslovi učešća",
    first_stop: "Bridgestone garancija na gume",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Kontrolna tabla",
    accountDashboard: "Kontrolna tabla",
    account: "Profil",
    mailbox: "Primljena pošta",
    singleMailbox: "Poruke",
    stammdaten: "Osnovni podaci",
    news_feeds: "Vesti",
    pointsOverview: "Pregled poena",
    rewardsOverview: "Pregled poena",
    about: "O BS Plus",
    service_number: "Kontakt servis",
    shop: "Shop nagrada",
    salesPromotions: "Prodajne promocije",
    promotions: "Moj nalog",
    shopCategory: "Shop nagrada",
    productDetails: "Detalji proizvoda",
    userOrders: "Korisničke narudžbe",
    shoppingCart: "Korpa",
    orderDelivery: "Adresa za dostavu",
    orderSummary: "Pregled narudžbe",
    orderComplete: "Narudžba završena",
    staff: "Kontrolna tabla servisa",
    onlineTrainings: "Onlajn treninge",
    trainings: "Treninge",
    training: "Trening",
    trainingForm: "Forma za trening",
    staffVouchers: "Vaučeri",
    wholesalerVouchers: "Vaučeri",
    brochure_prices: "Cenovnici i brošure",
    investment: "Podrska investicijama",
    media: "Mediji",
    medias: "Mediji",
    wholesaler: "Kontrolna tabla veletrgovca",
    contact_service: "Kontakt informacije i servis",
    productInfo: "INFORMACIJE O PROIZVODU",
    bDrive: "Slike proizvoda",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Uslovi učešća",
    first_stop: "Bridgestone garancija na gume",
    payouts: "Payouts",
},
  menu: {
    account: "Profil",
    plus: 'O Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Prodajna podrška",
    mailbox: "Primljena pošta",
    about: "O BS Plus",
    trainingAndCourses: "Treninge i kursevi",
    externalTraining: "Spoljašnji treninge",
    productInfo: "Informacije o proizvodu",
    productBrochures: "Brošure proizvoda",
    priceLists: "Cenovnici",
    price: "Cena",
    complaintForm: "Forma za žalbu",
    sales_support: "Prodajna podrška",
    contact_service: "Kontakt informacije i servis",
    logOut: "Odjavite se",
    news: "Vesti",
    news_feeds: "Vesti",
    service_number: "Kontakt servis",
    salesPromotions: "Prodajne promocije",
    shop: "Prodavnica",
    onlineTrainings: "Onlajn treninge",
    trainings: "Treninge",
    brochure_prices: "Cenovnici i brošure",
    media: "Mediji",
    medias: "Mediji",
    stammdaten: "Osnovni podaci",
    preislisten: "Cenovnici",
  },
  validation: {
    requiredField: "Polje je obavezno",
  },
  sortBy: {
    default: "Sortirajte po",
    desc: "Sortirajte po: Najnovije",
    asc: "Sortirajte po: Najstarije",
    name: "Ime",
    date: "Datum",
    choiceBy: "Sortirajte",
  },
  month: {
    1: "januar",
    2: "februar",
    3: "mart",
    4: "april",
    5: "maj",
    6: "jun",
    7: "jul",
    8: "avgust",
    9: "septembar",
    10: "oktobar",
    11: "novembar",
    12: "decembar"
  },
};


export default {
  messages,
};
